<template>
  <div class="image-detection-container">

    <!-- 右侧主要内容区 -->
    <div class="main-content">
      <!-- 顶部统计卡片 -->
      <div class="stats-cards">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="stat-card safe">
              <div class="stat-icon">
                <i class="el-icon-success"></i>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ stats.none }}</div>
                <div class="stat-label">安全图片</div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card warning">
              <div class="stat-icon">
                <i class="el-icon-warning"></i>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ stats.low }}</div>
                <div class="stat-label">存在风险</div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card danger">
              <div class="stat-icon">
                <i class="el-icon-error"></i>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ stats.high }}</div>
                <div class="stat-label">严重违规</div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card total">
              <div class="stat-icon">
                <i class="el-icon-pie-chart"></i>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ stats.total }}</div>
                <div class="stat-label">总检测数</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 检测功能区 -->
      <div class="detection-area">
        <el-card class="upload-card" shadow="hover">
          <div slot="header" class="card-header">
            <span><i class="el-icon-upload"></i> 图片上传检测</span>
            <div class="header-buttons">
              <el-button size="small" @click="clearAll">清空</el-button>
              <!-- <el-button size="small" type="primary" @click="showSettings = true">检测设置</el-button> -->
            </div>
          </div>

          <!-- 上传区域 -->
          <div class="upload-section">
            <el-upload
              ref="upload"
              class="upload-dragger"
              drag
              :action="uploadUrl"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :show-file-list="false"
              accept="image/*"
              :loading="uploading"
              :headers="uploadHeaders"
            >
              <!-- 上传前显示 -->
              <div v-if="!imageUrl" class="upload-content">
                <i class="el-icon-upload upload-icon"></i>
                <div class="upload-text">
                  <p>将图片拖拽到此处，或<em>点击上传</em></p>
                  <p class="upload-hint">支持 JPG、PNG格式，大小不超过10MB</p>
                </div>
              </div>

              <!-- 上传成功后显示图片预览 -->
              <div v-else class="upload-preview">
                <img :src="imageFullUrl" alt="上传成功图片" class="preview-img" />
                <span class="close-btn" @click.stop="removeImage" v-if="imageFullUrl != ''">×</span>
              </div>
            </el-upload>

            <!-- 快捷功能按钮 -->
            <!-- <div class="quick-actions">
              <el-button @click="openCamera" icon="el-icon-camera" size="small">拍照检测</el-button>
              <el-button @click="pasteFromClipboard" icon="el-icon-document-copy" size="small">粘贴图片</el-button>
              <el-button @click="selectFromGallery" icon="el-icon-picture" size="small">从相册选择</el-button>
            </div> -->
          </div>

          <!-- 检测进度 -->
           <div v-if="imageUrl && detecting == false" style="text-align: center;">
              <el-button type="primary" @click="examine">开始检测</el-button>
           </div>
          <div v-if="detecting" class="detection-progress">
            <el-progress
              :percentage="detectionProgress"
              :stroke-width="8"
              :show-text="false"
            ></el-progress>
            <p class="progress-text">{{ progressText }}</p>
          </div>
        </el-card>

        <!-- 检测结果区域 -->
        <div v-if="detectionResults && detectionResults.length" class="results-section">
          <el-card v-for="(result, index) in detectionResults" :key="index" class="result-card" shadow="hover">
            <div class="result-header">
              <span class="result-title">检测结果 #{{ index + 1 }}</span>
              <span class="detection-time">{{ result.attachment.filename }}</span>
              <el-tag
                :type="getResultType(result.riskLevel)"
                size="small"
              >
                {{ getResultText(result.riskLevel) }}
              </el-tag>
            </div>

            <div class="result-content">
              <div class="image-preview">
                <div style="text-align: center;">
                  <el-image 
                    style="width: 100px; height: 100px"
                    :src="result.image" 
                    :preview-src-list="srcList"
                    fit="cover"
                  >
                  </el-image>
                </div>
                <div class="image-info">
                  <p><strong>文件名:</strong> {{ result.attachment.filename }}</p>
                  <p><strong>大小:</strong> {{ result.attachment.filesize_text }}</p>
                  <p><strong>检测时间:</strong> {{ result.createtime_text }}</p>
                  <!-- <p><strong>分辨率:</strong> {{ result.dimensions }}</p> -->
                </div>
              </div>

              <div class="detection-details">
                <div v-if="result.riskLevel == 'none'" class="safe-result">
                  <i class="el-icon-success"></i>
                  <p>恭喜！该图片未检测到违规内容</p>
                  <!-- <div class="confidence-score">
                    <span>安全评分:</span>
                    <el-progress
                      :percentage="result.confidence"
                      :stroke-width="6"
                      :show-text="false"
                      status="success"
                    ></el-progress>
                    <span class="score-text">{{ result.confidence }}%</span>
                  </div> -->
                </div>

                <div v-else class="violation-result">
                  <div class="violation-header">
                    <i class="el-icon-warning-outline"></i>
                    <span>检测到 {{ result.violations.length }} 项违规内容</span>
                  </div>

                  <div class="violations-list">
                    <div
                      v-for="(violation, vIndex) in result.violations"
                      :key="vIndex"
                      class="violation-item"
                    >
                      <div class="violation-info">
                        <el-tag
                          :type="getViolationType(violation.riskLevel)"
                          size="mini"
                        >
                          {{ getResultText(violation.riskLevel) }}
                        </el-tag>
                        <span class="violation-desc">{{ violation.description }}</span>
                        <div class="confidence-bar">
                          <span class="confidence-label">置信度:</span>
                          <el-progress
                            :percentage="violation.confidence"
                            :stroke-width="4"
                            :show-text="false"
                            :status="getProgressStatus(violation.confidence)"
                          ></el-progress>
                          <span class="confidence-value">{{ violation.confidence }}%</span>
                        </div>
                      </div>
                      <!-- <div v-if="violation.location" class="violation-location">
                        <span>位置: {{ violation.location }}</span>
                      </div> -->
                    </div>
                  </div>

                  <!-- 处理建议 -->
                  <!-- <div class="suggestions">
                    <h4><i class="el-icon-info"></i> 处理建议</h4>
                    <ul>
                      <li v-for="suggestion in result.suggestions" :key="suggestion">
                        {{ suggestion }}
                      </li>
                    </ul>
                  </div> -->
                </div>

                <!-- 详细分析 -->
                <!-- <div class="detailed-analysis">
                  <el-collapse>
                    <el-collapse-item title="其他信息" name="1">
                      <div class="analysis-content">
                        <el-row :gutter="20">
                          <el-col :span="12">
                            <h5>检测维度</h5>
                            <div class="dimension-item" v-for="dimension in result.dimensions" :key="dimension.name">
                              <span>{{ dimension.name }}</span>
                              <el-rate
                                v-model="dimension.score"
                                :max="5"
                                disabled
                                show-score
                                text-color="#ff9900"
                                score-template="{value}"
                              >
                              </el-rate>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <h5>技术参数</h5> -->
                            <!-- <p><strong>检测耗时:</strong> {{ result.processingTime }}ms</p>
                            <p><strong>AI模型:</strong> Image_vl_standard</p>
                            <p><strong>检测版本:</strong> BaselineCheckByVL</p>
                          </el-col>
                        </el-row>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div> -->
              </div>
            </div>

            <div class="result-actions">
              <!-- <el-button size="small" @click="downloadReport(result)">
                <i class="el-icon-download"></i> 下载报告
              </el-button>
              <el-button size="small" @click="shareResult(result)">
                <i class="el-icon-share"></i> 分享结果
              </el-button> -->
              <!-- <el-button size="small" @click="redetect(result)" type="primary">
                <i class="el-icon-refresh"></i> 重新检测
              </el-button> -->
              <el-button size="small" @click="removeResult(result.id)" type="danger">
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </div>
          </el-card>
        </div>
      </div>
    </div>

    <!-- 检测设置弹窗 -->
    <el-dialog
      title="检测设置"
      :visible.sync="showSettings"
      width="500px"
    >
      <el-form :model="settings" label-width="120px">
        <el-form-item label="检测类型">
          <el-checkbox-group v-model="settings.detectionTypes">
            <el-checkbox label="违法违规">违法违规内容</el-checkbox>
            <el-checkbox label="暴力血腥">暴力血腥内容</el-checkbox>
            <el-checkbox label="色情低俗">色情低俗内容</el-checkbox>
            <el-checkbox label="恶心内容">恶心不适内容</el-checkbox>
            <el-checkbox label="广告推广">广告推广内容</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="检测精度">
          <el-radio-group v-model="settings.precision">
            <el-radio label="fast">快速检测</el-radio>
            <el-radio label="standard">标准检测</el-radio>
            <el-radio label="high">高精度检测</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="置信度阈值">
          <el-slider
            v-model="settings.confidenceThreshold"
            :min="50"
            :max="95"
            show-input
            style="margin-right: 20px;"
          ></el-slider>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSettings = false">取 消</el-button>
        <el-button type="primary" @click="saveSettings">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { baseURL } from '@/utils/request'
export default {
  name: 'ImageDetection',
  data() {
    return {
      imgUrl:baseURL,
      uploadUrl: baseURL+'/api/common/upload', // 你的后端API地址
      uploadHeaders:{
        "Token" : localStorage.getItem('token')
      },
      imageUrl: '',
      imageFullUrl: '',
      fileId: 0,
      uploading: false,
      detecting: false,
      detectionProgress: 0,
      progressText: '准备检测...',
      showSettings: false,
      page:1,
      
      // 统计数据
      stats: {
        high: 0,
        low: 0,
        medium: 0,
        none: 0,
        total: 0
      },
      
      // 检测设置
      settings: {
        detectionTypes: ['违法违规', '暴力血腥', '色情低俗'],
        precision: 'standard',
        confidenceThreshold: 80
      },
      
      // 检测结果
      detectionResults: [],
      detectionTimer:null,
      srcList:[]
    }
  },
  created(){
    this.getData()
  },
  methods: {
    async getData(){
      try {
        // 调用后端接口
        const res = await this.$api.post('/api/examine/imageExamineList', {page:this.page})
        if(res.code == 1){
          Object.assign(this.stats, res.data.count)

          // 用 Vue.set 或解构确保响应式更新
          this.$set(this, 'detectionResults', res.data.list.data)
          this.srcList = res.data.list.data.map(item => item.image)
          this.$nextTick(() => {
            console.log('更新后检测结果:', this.detectionResults.length)
          })
        }
      } catch (err) {
        console.error('获取失败:', err)
        this.$message.error(err.message || '数据获取失败')
      } finally {
        this.loading = false
      }
    },
    // 文件上传前验证
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB!');
        return false;
      }

      this.uploading = true;
      //this.startDetection();
      return true;
    },

    // 上传成功回调
    handleUploadSuccess(response) {
      if(response.code == 1){
        this.imageUrl = response.data.url
        this.imageFullUrl = response.data.fullurl
        this.fileId = response.data.file_id
        this.$message.success('上传成功')
      }else{
        this.$message.error(response.msg || '上传失败')
      }
      // this.uploading = false;
      // this.detecting = false;
      
      // // 这里处理后端返回的检测结果
      // if (response.success) {
      //   this.detectionResults.unshift(response.data);
      //   this.updateStats();
      //   this.$message.success('图片检测完成！');
      // } else {
      //   this.$message.error(response.message || '检测失败！');
      // }
    },

    // 上传失败回调
    handleUploadError(error) {
      this.uploading = false;
      this.detecting = false;
      this.$message.error('上传失败，请重试！');
    },

    async removeImage() {
      this.loading = true
      try {
        // 调用后端接口
        const res = await this.$api.post('/api/examine/clearImageExamine', {})
        this.$message.success(res.msg);
        if(res.code == 1){
          this.imageUrl = '' // 清空图片
          this.$refs.upload.clearFiles() // 清除上传记录
        }
      } catch (err) {
        this.$message.error(err.message || '数据操作失败')
      } finally {
        this.loading = false
      }
    },

    async examine() {
      if (this.imageUrl === '') {
        this.$message.error('请上传要审查的图片');
        return;
      }

      this.loading = true;
      this.detecting = true; // 一点击就开始检测动画
      this.detectionProgress = 0;
      this.progressText = '正在准备上传图片...';
      this.startDetection(true); // 启动动画模式（等待上传）

      try {
        // 调用后端接口
        const res = await this.$api.post('/api/examine/addImageExamine', {
          imgUrl: this.imageUrl,
          imgFullUrl: this.imageFullUrl,
          file_id: this.fileId
        });

        if (res.code !== 1) {
          throw new Error(res.msg || '上传失败');
        }

        // 上传成功，继续检测
        this.progressText = '上传成功，开始分析图片...';
      } catch (err) {
        console.error('上传失败:', err);
        this.$message.error(err.message || '上传失败');
        // 上传失败 → 终止检测动画
        this.detecting = false;
        this.loading = false;
        this.detectionProgress = 0;
        if (this.detectionTimer) clearInterval(this.detectionTimer);
        return;
      } finally {
        this.loading = false;
      }
    },


    // 开始检测动画
    startDetection() {
      this.detecting = true;
      this.detectionProgress = 0;

      const steps = [
        { progress: 25, text: '正在上传图片...' },
        { progress: 50, text: '初始化AI模型...' },
        { progress: 75, text: '分析图片内容...' },
        { progress: 100, text: '检测完成！' }
      ];

      let stepIndex = 0;
      const timer = setInterval(() => {
        if (!this.detecting) {
          clearInterval(timer);
          return;
        }

        if (stepIndex < steps.length) {
          this.detectionProgress = steps[stepIndex].progress;
          this.progressText = steps[stepIndex].text;
          stepIndex++;
        } else {
          clearInterval(timer);
          this.detecting = false;
          this.imageUrl = '';
          this.updateStats();
        }
      }, 800);

      // 记录 timer 以便上传失败时清除
      this.detectionTimer = timer;
    },


    // 获取结果类型样式
    getResultType(status) {
      const types = {
        'none': 'success',
        'medium': 'warning', 
        'low': 'warning', 
        'high': 'danger'
      };
      return types[status] || 'info';
    },

    // 获取结果文本
    getResultText(status) {
      const texts = {
        'none': '安全',
        'medium': '警告',
        'low': '警告',
        'high': '违规'
      };
      return texts[status] || '未知';
    },

    // 获取违规类型样式
    getViolationType(severity) {
      const types = {
        'low': 'info',
        'medium': 'warning',
        'high': 'danger'
      };
      return types[severity] || 'info';
    },

    // 获取进度条状态
    getProgressStatus(confidence) {
      if (confidence >= 80) return 'exception';
      if (confidence >= 60) return 'warning';
      return 'success';
    },

    // 更新统计数据
    updateStats() {
      // 根据检测结果更新统计
      // this.stats.total = this.detectionResults.length;
      // this.stats.safe = this.detectionResults.filter(r => r.status === 'safe').length;
      // this.stats.warning = this.detectionResults.filter(r => r.status === 'warning').length;
      // this.stats.danger = this.detectionResults.filter(r => r.status === 'violation').length;
      this.getData();
    },

    // 快捷功能
    openCamera() {
      this.$message.info('拍照功能开发中...');
    },

    pasteFromClipboard() {
      this.$message.info('剪贴板功能开发中...');
    },

    selectFromGallery() {
      this.$refs.upload.$el.querySelector('input').click();
    },

    // 结果操作
    downloadReport(result) {
      this.$message.success('报告下载中...');
    },

    shareResult(result) {
      this.$message.info('分享功能开发中...');
    },

    redetect(result) {
      this.$message.info('重新检测中...');
    },

    removeResult(index) {
      this.$confirm('确定删除这个检测结果吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        this.loading = true
        try {
          // 调用后端接口
          const res = await this.$api.post('/api/examine/delImageExamine', {id:index})
          this.$message.success(res.msg);
          if(res.code == 1){
            this.updateStats();
          }
        } catch (err) {
          this.$message.error(err.message || '数据操作失败')
        } finally {
          this.loading = false
        }
      }).catch(()=>{
        this.loading = false
      });
    },

    // 清空所有结果
    clearAll() {
      this.$confirm('确定清空所有检测结果吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true
        try {
          // 调用后端接口
          const res = await this.$api.post('/api/examine/clearImageExamine', {})
          this.$message.success(res.msg);
          if(res.code == 1){
            this.detectionResults = [];
            this.updateStats();
          }
        } catch (err) {
          this.$message.error(err.message || '数据操作失败')
        } finally {
          this.loading = false
        }
      }).catch(()=>{
        this.loading = false
      });
    },

    // 保存设置
    saveSettings() {
      this.$message.success('设置保存成功！');
      this.showSettings = false;
    }
  }
}
</script>

<style scoped>
.image-info {
  margin-top: 10px;
  font-size: 12px;
  color: #606266;
}

.image-info p {
  margin: 4px 0;
}

.detection-details {
  flex: 1;
}

/* 安全结果样式 */
.safe-result {
  text-align: center;
  padding: 30px 20px;
  background: #f0f9ff;
  border-radius: 8px;
  border: 1px solid #e1f5fe;
}

.safe-result i {
  font-size: 48px;
  color: #67c23a;
  margin-bottom: 15px;
}

.safe-result p {
  font-size: 16px;
  color: #303133;
  margin-bottom: 20px;
}

.confidence-score {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.score-text {
  font-weight: bold;
  color: #67c23a;
}

/* 违规结果样式 */
.violation-result {
  background: #fef0f0;
  border: 1px solid #fbc4c4;
  border-radius: 8px;
  padding: 20px;
}

.violation-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: bold;
  color: #f56c6c;
  margin-bottom: 15px;
}

.violations-list {
  margin-bottom: 20px;
}

.violation-item {
  background: white;
  border: 1px solid #fbc4c4;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 10px;
}

.violation-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.violation-desc {
  flex: 1;
  min-width: 150px;
  color: #303133;
}

.confidence-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 200px;
}

.confidence-label {
  font-size: 12px;
  color: #606266;
}

.confidence-value {
  font-size: 12px;
  font-weight: bold;
}

.violation-location {
  margin-top: 10px;
  font-size: 12px;
  color: #909399;
}

/* 建议样式 */
.suggestions {
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 6px;
  padding: 15px;
  margin-top: 15px;
}

.suggestions h4 {
  margin: 0 0 10px 0;
  color: #fa8c16;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.suggestions ul {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
}

.suggestions li {
  color: #595959;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 5px;
}

/* 详细分析 */
.detailed-analysis {
  margin-top: 20px;
}

.analysis-content h5 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 14px;
}

.dimension-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
}

.analysis-content p {
  margin: 5px 0;
  font-size: 13px;
  color: #606266;
}

/* 操作按钮 */
.result-actions {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.result-actions .el-button {
  padding: 5px 15px;
}


/* 动画效果 */
.result-card {
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 加载状态 */
.upload-dragger.is-dragover {
  border-color: #409eff;
  background-color: rgba(64, 158, 255, 0.06);
}

/* 设置对话框样式 */
.dialog-footer {
  text-align: center;
}

/* Element UI 组件样式调整 */
.el-card {
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.el-card__header {
  border-bottom: 1px solid #f0f2f5;
}

.el-upload-dragger {
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  background-color: #fafafa;
  transition: all 0.3s;
}

.el-upload-dragger:hover {
  border-color: #409eff;
}

.el-progress-bar__outer {
  border-radius: 100px;
}

.el-progress-bar__inner {
  border-radius: 100px;
}

.el-tag {
  border: none;
  font-weight: 500;
}

.el-collapse {
  border: none;
}

.el-collapse-item__header {
  background-color: #fafafa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding-left: 15px;
}

.el-collapse-item__wrap {
  border: none;
}

.el-collapse-item__content {
  padding: 15px;
  background-color: #fafafa;
}

.el-rate {
  height: auto;
}

.el-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.el-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}detection-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
}



/* 主内容区 */
.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

/* 统计卡片 */
.stats-cards {
  margin-bottom: 20px;
}

.stat-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 24px;
}

.stat-card.safe .stat-icon {
  background: #e8f5e8;
  color: #67c23a;
}

.stat-card.warning .stat-icon {
  background: #fdf6ec;
  color: #e6a23c;
}

.stat-card.danger .stat-icon {
  background: #fef0f0;
  color: #f56c6c;
}

.stat-card.total .stat-icon {
  background: #e6f7ff;
  color: #409eff;
}

.stat-info {
  flex: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-top: 4px;
}

/* 检测区域 */
.detection-area {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.upload-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-buttons .el-button {
  margin-left: 8px;
}

.upload-section {
  padding: 20px 0;
}

.upload-dragger {
  width: 100%;
  text-align: center;
}

.upload-content {
  text-align: center;
  padding: 0 20px;
}

.upload-icon {
  font-size: 48px;
  color: #c0c4cc;
  margin-bottom: 16px;
}

.upload-text p {
  margin: 8px 0;
}

.upload-hint {
  font-size: 12px;
  color: #909399;
}

.quick-actions {
  text-align: center;
  margin-top: 20px;
}

.quick-actions .el-button {
  margin: 0 5px;
}

/* 检测进度 */
.detection-progress {
  padding: 20px;
  text-align: center;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 20px 0;
}

.progress-text {
  margin-top: 10px;
  color: #606266;
  font-size: 14px;
}

/* 结果区域 */
.results-section {
  margin-top: 20px;
}

.result-card {
  margin-bottom: 20px;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 20px;
}

.result-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.detection-time {
  font-size: 12px;
  color: #909399;
}

.result-content {
  display: flex;
  gap: 20px;
}

.image-preview {
  flex-shrink: 0;
  width: 200px;
}

.image-preview img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

/* 上传后显示的图片样式 */
.upload-preview {
  position: relative;
  display: inline-block;
  height: 100%;
}

.preview-img {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

/* 右上角 × 按钮 */
.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(0,0,0,0.5);
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 18px;
  cursor: pointer;
  font-weight: bold;
}
.close-btn:hover {
  background: rgba(0,0,0,0.7);
}
</style>